import {Component, OnDestroy, OnInit} from '@angular/core';
import {CardsBasicComponent} from "../../../../shared/components/cards/cards-basic/cards-basic.component";
import {DjangoApiService} from "../../../../shared/services/django-api.service";
import {Subscription} from "rxjs";
import {LanguageService} from "../../../../shared/services/language.service";
import {LangChangeEvent, TranslateModule, TranslateService} from "@ngx-translate/core";
import {LocalizeRouterPipe} from "@gilsdav/ngx-translate-router";
import {RouterLink} from "@angular/router";
import {NgClass} from "@angular/common";
import {LocalizedDatePipe} from "../../../../shared/pipes/localized-date.pipe";
import {ChartsComponent} from "../../../charts/charts/charts.component";
import {MatAnchor} from "@angular/material/button";
import {MatProgressSpinner} from "@angular/material/progress-spinner";
import {SnackbarService} from "../../../../shared/services/snackbar.service";

@Component({
  selector: 'app-product-list',
  standalone: true,
  imports: [
    CardsBasicComponent,
    LocalizeRouterPipe,
    RouterLink,
    TranslateModule,
    LocalizedDatePipe,
    ChartsComponent,
    MatAnchor,
    MatProgressSpinner,
    NgClass
  ],
  templateUrl: './product-list.component.html',
  styleUrl: './product-list.component.css'
})
export class ProductListComponent implements OnInit, OnDestroy {
  dataSource!: any;
  categoryData!: any;
  currentLanguage!: string;
  bestProduct!: any;
  testYes = false;
  langChangeSubscription: Subscription | null = null;
  private subscriptions: Subscription = new Subscription();

  constructor(private _apiService: DjangoApiService,
              private _languageService: LanguageService,
              private _translate: TranslateService,
              private _snackbarService: SnackbarService) {
  }


  /**
   * Initializes the component.
   *
   * @return {void} No return value.
   */
  ngOnInit(): void {
    this.loadCategoryData()
    this.manageSubscriptions();
    this.currentLanguage = this._languageService.getLanguage();
  }


  private loadCategoryData(): void {
    this.subscriptions.add(
      this._apiService.fetchCategoryProductList().subscribe({
        next: (res: any) => {
          this.categoryData = res;

          this.categoryData.forEach((category: any) => {
            if (category.products && Array.isArray(category.products)) {
              category.products.forEach((prodEntry: any) => {
                if (prodEntry.product) {
                  this.loadProductChartData(prodEntry.product);
                }
              });
            }
          });

          console.log(this.categoryData);
        },
        error: (error) => {
          console.error('There was an error fetching this category data.', error);
        }
      })
    );
  }



  loadProductChartData(product: any): void {
    const interval = 'monthly';
    const benchmarkIDs: number[] = []; // Provide valid benchmark IDs
    const startDate: string = ''; // Provide a valid start date
    const endDate: string = ''; // Provide a valid end date
    const statistic = 'performance'; // Set the statistic to 'performance'

    // Iterate over each product in the dataSource
    this.subscriptions.add(
      this._apiService.fetchChartData(product.id, benchmarkIDs, startDate, endDate, interval, statistic).subscribe({
        next: (response: any) => {
          // Attach chartData to each product
          product.chartData = response;
        },
        error: (error) => {
          console.error('Error fetching chart data for product ID:', product.id, error);
        }
      })
    );
  }



  /**
   * Manages the subscriptions for language change events.
   *
   * @private
   * @return {void}
   */
  private manageSubscriptions(): void {
    this.subscriptions.add(
      this.langChangeSubscription = this._translate.onLangChange
        .subscribe((event: LangChangeEvent) => {
          this.currentLanguage = event.lang;
        })
    );
  }


  /**
   * Performs cleanup actions when the component is destroyed.
   *
   * It unsubscribes the component's subscriptions to prevent memory leaks.
   *
   * @memberof Component
   * @method ngOnDestroy
   * @returns {void}
   */
  ngOnDestroy(): void {
    this.subscriptions.unsubscribe();
  }

}
